import { Component, OnDestroy, OnInit } from "@angular/core";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { RouterService } from "src/app/services/router/router.service";
import { ShoppingCartService } from "src/app/services/shopping-cart/shopping-cart.service";
import { StorageService } from "src/app/services/storage/storage.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { Location } from "@angular/common";
import { LoaderService } from "src/app/services/loader/loader.service";
import { ModalController } from "@ionic/angular";
import { QuantumService } from "src/app/services/quantum/quantum.service";
import { RedemptionService } from "src/app/services/redemption/redemption.service";
import { CredentialsService } from "src/app/services/credentials/credentials.service";
import { UserService } from "src/app/services/user/user.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { ActivatedRoute } from '@angular/router';
import { CanExchangeService } from 'src/app/services/can-exchange/can-exchange.service';
import { CanExChange } from 'src/app/interfaces/ICanExchange';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.page.html',
  styleUrls: ['./shopping-cart.page.scss'],
})
export class ShoppingCartPage implements OnInit, OnDestroy {
  productsTypeProduct = [];
  productsTypeVirtual = [];
  productsTypeRecharges = [];
  productsTypeDaviplata = [];
  productsTypeNoIddoc = [];
  productsTypeBonosExito = [];
  productsQuantum = {};
  products: any = [];
  totalPointsProducts = 0;
  userPoints = 0;
  checkoutData;
  addressConfirm = false;
  phoneRechargeConfirm = false;
  reloadableCardConfirm = false;
  reloadableCardConfirmNoIddoc = false;
  ableButton = true;
  LOADER_ID = 'shopping-cart';
  showAlertPoints = false;
  userInfo: any = {};
  loading = true;
  fromAddress = false;
  page = "";

  canExchange: any;
  constructor(
    public languageService: LanguagesService,
    private routerService: RouterService,
    private utilsService: UtilsService,
    private shoppingCartService: ShoppingCartService,
    private localStorage: StorageService,
    private location: Location,
    private loaderService: LoaderService,
    private modalController: ModalController,
    private quantumService: QuantumService,
    private redemptionService: RedemptionService,
    private credentialsService: CredentialsService,
    private userService: UserService,
    private authService: AuthService,
    private canExchangeService: CanExchangeService,
    private route: ActivatedRoute) { }
    

  async ngOnInit() {
    const userFirebase = await this.authService.getUSerInfoFromFirebase();
    this.userService.getUserInfo().subscribe(async (basicUserInfo: any) => {
      this.userInfo.username = basicUserInfo.gnxCredential1;
      this.userInfo.name = basicUserInfo.name.trim();
      this.userInfo.lastname = basicUserInfo.lastnames.trim();
      this.userInfo.docId =
        basicUserInfo.docNumber || basicUserInfo.gnxCredential1;
      this.userInfo.email =
        userFirebase.email.split("@")[1] == "nomail.glukynet.com"
          ? ""
          : userFirebase.email;
    });
    this.canExchanges();
  }

  async ionViewWillEnter() {
    this.modalController.dismiss(null, null, "catalogue-detail-modal");
    await this.getData();
  }

  async getData() {
    this.page = "";
    this.checkoutData = {};
    await this.loaderService.presentLoading(this.LOADER_ID);
    await this.shoppingCartService.getCart().then(async (data: any) => {
      this.totalPointsProducts = data.totalPoints;
      this.products = data.items;

      if (data.checkoutData) {
        const checkout = data.checkoutData;
        if(checkout.quantum){
          (Object.values(checkout.quantum)).map((x: any) => {
            const exits = (Object.values(this.products)).filter((p: any) => p.sku == x.sku)[0]
            if(!exits){
              delete data.checkoutData.quantum[x.sku];
            }
          })
          await this.localStorage.set("checkoutData", data.checkoutData);
          this.checkoutData = await data.checkoutData;
          console.log("quantum checkoutData == ", this.checkoutData);
        }else{
          this.checkoutData = {...data.checkoutData};
        }
      }

      await this.getEnableButton();
      await this.getPoints();
      await this.getProducts();
      await this.loaderService.cancelLoader(this.LOADER_ID);
      this.route.queryParams.subscribe((params) => {
        if(params.data){
          this.fromAddress = JSON.parse(params.data).fromAddress;
          if(this.fromAddress){
            this.page = "/app/catalogue";
          } else {
            this.page = "";
          }
        }
      });
    }).catch(async (error) => {
      await this.loaderService.cancelLoader(this.LOADER_ID);
    })
  }

  async getEnableButton() {
    this.addressConfirm = false;
    this.phoneRechargeConfirm = false;
    this.reloadableCardConfirm = false;
    this.reloadableCardConfirmNoIddoc = false;
    this.checkoutData = this.checkoutData ? this.checkoutData : await this.localStorage.get('checkoutData');
    if (this.checkoutData) {
      if (this.checkoutData.address) {
        this.addressConfirm = true;
      }
      if (this.checkoutData.reloadableCard) {
        this.reloadableCardConfirm = true;
      }
      if (this.checkoutData.reloadableCardNoIdDoc) {
        this.reloadableCardConfirmNoIddoc = true;
      }
      if (this.checkoutData.phoneRecharge) {
        this.phoneRechargeConfirm = true;
      }
    }
  }

  getPoints() {
    this.utilsService.getUserPoints().then(async (points: any) => {
      this.userPoints = points;
      if (
        this.totalPointsProducts != 0 &&
        this.totalPointsProducts > this.userPoints
      ) {
        this.showAlertPoints = true;
      } else {
        this.showAlertPoints = false;
      }
    });
  }

  async getProducts() {
    this.ableButton = true;
    this.productsTypeDaviplata = [];
    this.productsTypeNoIddoc = [];
    this.productsTypeProduct = [];
    this.productsTypeVirtual = [];
    this.productsTypeRecharges = [];
    this.productsTypeBonosExito = [];
    this.productsQuantum = [];
    this.products = Object.values(this.products);

    const types = ["bonos", "voucher"];
    await this.products.map((x, index) => {
      if (x.type == "voucher") {
        this.quantumService.requestProductQuantum(x.sku).then((res) => {
          const productQuantum = {
            site_id: "",
            site_name: "",
            dep_id: "",
            dep_name: "",
            city_id: "",
            city_name: "",
            birthdate: "",
            sku: x.sku,
          };
          this.productsQuantum[x.sku] = productQuantum;
          this.checkoutData.quantum = this.checkoutData.quantum
            ? this.checkoutData.quantum
            : {};
          this.checkoutData.quantum[x.sku] = this.checkoutData.quantum[x.sku] ? this.checkoutData.quantum[x.sku] :productQuantum;
          if (res.brand.sites) {
            this.products[index].isTraceable = true;
            if (this.checkoutData.quantum[x.sku].site_id) {
              this.products[index].dataComplete = true;
            } else {
              this.products[index].dataComplete = false;
              this.ableButton = false;
            }
          }
        });
      }
      if (x.type == 'product') {
        this.productsTypeProduct.push(x);
        this.ableButton = this.addressConfirm;
      }
      if (x.type == 'bonos_exito') {
        this.productsTypeProduct.push(x);
        this.ableButton = this.addressConfirm;
      }
      if (x.type == 'reloadable_card') {
        this.productsTypeDaviplata.push(x);
        this.ableButton = !this.ableButton ? false : this.reloadableCardConfirm;
      }
      if (x.type == "reloadable_card_no_iddoc") {
        this.productsTypeNoIddoc.push(x);
        this.ableButton = !this.ableButton ? false : this.reloadableCardConfirmNoIddoc;
      }
      if (x.type == "cellphone_credit") {
        this.productsTypeRecharges.push(x);
        this.ableButton = !this.ableButton ? false : this.phoneRechargeConfirm;
      }
      if (x.type == "bonos_exito") {
        this.productsTypeBonosExito.push(x);
        //this.ableButton = this.addressConfirm;
        this.ableButton = true;
      }
      if (types.includes(x.type)) {
        this.productsTypeVirtual.push(x);
      }
      this.productsTypeProduct = this.productsTypeProduct.sort((a, b) => {
        if (a.sku > b.sku) {
          return 1;
        }
        if (a.sku < b.sku) {
          return -1;
        }
        return 0;
      });
      this.productsTypeVirtual = this.productsTypeVirtual.sort((a, b) => {
        if (a.sku > b.sku) {
          return 1;
        }
        if (a.sku < b.sku) {
          return -1;
        }
        return 0;
      });
      this.productsTypeDaviplata = this.productsTypeDaviplata.sort((a, b) => {
        if (a.sku > b.sku) {
          return 1;
        }
        if (a.sku < b.sku) {
          return -1;
        }
        return 0;
      });
      this.productsTypeNoIddoc = this.productsTypeNoIddoc.sort((a, b) => {
        if (a.sku > b.sku) {
          return 1;
        }
        if (a.sku < b.sku) {
          return -1;
        }
        return 0;
      });
      this.productsTypeBonosExito = this.productsTypeBonosExito.sort((a, b) => {
        if (a.sku > b.sku) {
          return 1;
        }
        if (a.sku < b.sku) {
          return -1;
        }
        return 0;
      });
      this.productsTypeRecharges = this.productsTypeRecharges.sort((a, b) => {
        if (a.sku > b.sku) {
          return 1;
        }
        if (a.sku < b.sku) {
          return -1;
        }
        return 0;
      });
    });
    this.loading = false;
  }

  get getTextIUCurrency() {
    return this.languageService.textsIU.currency_data;
  }

  getAdress = () => {
    this.routerService.redirectRootWithdata('/app/map/list', {
      fromShoppingCart: true,
    });
  };

  async checkRedemption() {
    const redemptionInfo = await this.redemptionService.getProgramInfo();
    if (redemptionInfo["redemption_limit"]?.enabled) {
      if (redemptionInfo["redemption_limit"]?.min_user_points_limit) {
        if (
          this.totalPointsProducts <
          redemptionInfo["redemption_limit"]?.min_user_points_limit
        ) {
          if (!this.redemptionService.IsOpen) {
            return this.redemptionService.openModal(
              'catalogue - this.productPrice < redemptionInfo["redemption_limit"]?.min_user_points_limit'
            );
          } else {
            return;
          }
        }
      }
      if (
        redemptionInfo["redemption_limit"]?.min_date &&
        redemptionInfo["redemption_limit"]?.max_date
      ) {
        if (
          redemptionInfo["redemption_limit"]?.min_date.length > 0 &&
          redemptionInfo["redemption_limit"]?.max_date.length > 0
        ) {
          const now = new Date();
          const minDate = new Date(
            redemptionInfo["redemption_limit"]?.min_date
          );
          const maxDate = new Date(
            redemptionInfo["redemption_limit"]?.max_date
          );
          if (now < minDate || now > maxDate) {
            if (!this.redemptionService.IsOpen) {
              return this.redemptionService.openModal(
                "catalogue now < minDate || now > maxDate"
              );
            } else {
              return;
            }
          }
        }
      }
      this.checkout();
    } else if (this.canExchange === CanExChange.EXCHANGE_DISABLED_BY_PADLOCK ){
      return this.canExchangeService.openModal('exchange');
    } else {
      this.checkout();
    }
  }

  async actionProduct(sku, action) {
    this.loading = true;
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    window.scrollTo(scrollLeft, scrollTop);
    let items = {};

    await this.products.map((product) => {
      items[product.sku] = {
        quantity: product.quantity
      };
    });
    const product = this.products.filter((x) => x.sku == sku)[0];
    switch (action) {
      case 'add':
        product.quantity = product.quantity + 1;
        break;
      case 'remove':
        product.quantity = product.quantity - 1;
        break;
      case 'delete':
        product.quantity = 0;
        break;
      default:
        product.quantity = product.quantity;
        break;
    }
    items[sku] = {
      quantity: product.quantity
    };
    this.shoppingCartService.updateCart(items).then((res) => {
      this.totalPointsProducts = res.totalPoints;
      this.products = res.items;
      this.getProducts();
      this.validateProducts(sku);
      this.getPoints();
      this.getEnableButton();
      window.onscroll = function () {};
    });
  }

  goBack() {
    this.location.back();
  }

  async validateProducts(sku?) {
    const { companyId, programId, appId } = this.credentialsOrders();

    this.checkoutData.companyId = companyId;
    this.checkoutData.programId = programId;
    this.checkoutData.appId = appId;
    this.checkoutData.user = this.userInfo;

    let body = this.checkoutData
      ? this.checkoutData
      : {
          companyId,
          programId,
          appId,
          user: this.userInfo,
        };
    if (!this.productsTypeProduct || this.productsTypeProduct.length <= 0) {
      if (this.checkoutData.address) {
        delete body.address;
      }
    }
    if (!this.productsTypeDaviplata || this.productsTypeDaviplata.length <= 0) {
      if (this.checkoutData.reloadableCard) {
        delete body.reloadableCard;
      }
    }
    if (!this.productsTypeNoIddoc || this.productsTypeNoIddoc.length <= 0) {
      if (this.checkoutData.reloadableCardNoIdDoc) {
        delete body.reloadableCardNoIdDoc;
      }
    }
    if (!this.productsTypeRecharges || this.productsTypeRecharges.length <= 0) {
      if (this.checkoutData.phoneRecharge) {
        delete body.phoneRecharge;
      }
    }
    if (sku) {
      if (body.quantum) {
        if (Object.entries(body.quantum).length > 0) {
          delete body.quantum[sku];
        }
      }
    }
    if (body.quantum) {
      if (Object.entries(body.quantum).length <= 0) {
        if (this.checkoutData.quantum) {
          delete body.quantum;
        }
      }
    }
    this.setCheckoutData(body);
  }

  setCheckoutData(body) {
    if (!body.user.email) {
      delete body.user.email;
    }
    if (!body.user.phone) {
      delete body.user.phone;
    }
    this.shoppingCartService.checkoutData(body).then(async (res) => {
      const checkout = res.checkoutData;
      if(checkout.quantum){
        (Object.values(checkout.quantum)).map((x: any) => {
          const exits = (Object.values(this.products)).filter((p: any) => p.sku == x.sku)[0]
          if(!exits){
            delete res.checkoutData.quantum[x.sku];
          }
        })
        // this.checkoutData = await res.checkoutData;
        // await this.localStorage.set("checkoutData", res.checkoutData);
      }
      this.checkoutData = await res.checkoutData;
        await this.localStorage.set("checkoutData", res.checkoutData);
    });
  }

  confirmCheckout(type, product?) {
    this.routerService.redirectRootWithdata('app/confirm-checkout', {
      type: type,
      product: product,
    });
  }

  credentialsOrders = () => {
    return this.credentialsService.orders();
  };

  async checkout() {
    if (this.productsQuantum && Object.keys(this.productsQuantum).length > 0) {
      this.checkoutData = this.checkoutData ? this.checkoutData : await this.localStorage.get("checkoutData");
      let body = this.checkoutData ? this.checkoutData : {};
      if (!this.checkoutData.companyId) {
        const { companyId, programId, appId } = this.credentialsOrders();
        body = {
          companyId,
          programId,
          appId,
          user: this.userInfo,
        };
      }
      if (!body.user.email) {
        delete body.user.email;
      }
      if (!body.user.email) {
        delete body.user.email;
      }
      Object.values(this.productsQuantum).map((x: any) => {
        body.quantum = body.quantum ? body.quantum : {};
        if (this.checkoutData?.quantum) {
          body.quantum[x.sku] = this.checkoutData.quantum[x.sku]
            ? this.checkoutData.quantum[x.sku]
            : this.productsQuantum[x.sku];
        } else {
          body.quantum[x.sku] = this.productsQuantum[x.sku];
        }
      });
      this.shoppingCartService.checkoutData(body).then(async (res) => {
        await this.localStorage.set("checkoutData", res.checkoutData);
        this.routerService.redirectRoot("app/checkout");
      });
    } else {
      this.routerService.redirectRoot('app/checkout');
    }
  }

  async canExchanges(){
    this.canExchange = await this.canExchangeService.getCanExchange();
    this.canExchange = this.canExchange.code
    
  }

  ngOnDestroy(): void {
    console.log('destroy entrooo');
  }
}
